import React from "react";
import {CallbackForm} from "../Form/CallbackForm";

export function CallbackFormMessage({text}: ({ text: string })): React.ReactElement {

    return (<CallbackForm text={text}/>);
}
